import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Flex from "./Flex";

interface PageTitleProps {
  title: string;
  route?: string;
}

export default function PageTitle({ title, route }: PageTitleProps) {
  const navigate = useNavigate();

  return (
    <Flex>
      <>
        {route && (
          <BackBtn
            onClick={() => {
              if (route) {
                navigate(route);
              }
            }}
          >
            <BackArrow className="material-icons-outlined">
              chevron_left
            </BackArrow>
          </BackBtn>
        )}
      </>

      <SPageTitle>{title}</SPageTitle>
    </Flex>
  );
}

const BackBtn = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  margin-bottom: 40px;

  &:hover {
    background-color: #ebecf0;
  }
`;

const BackArrow = styled.span`
  font-size: 24px;
  color: #000000 !important;
`;

const SPageTitle = styled.h1`
  font-size: 26px;
  line-height: 39px;
  text-align: left;
  color: #2f2f38;
  margin-bottom: 40px;
`;
